import { DatePipe, registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';

import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app.component';
import { ModalAtomModule } from './components/atoms/modal-atom/modal-atom.module';
import { ToastModule } from './components/atoms/toast/toast.module';
import { LoadingModule } from './components/molecules/loading/loading.module';
import { GraphQLModule } from './graphql.module';
import { versionCheckInitializerFactory } from './initializers/version-check.initializer';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AssessmentSelfManagementInformationModule } from './modules/assessment-self-management/components/assessment-self-management-information/assessment-self-management-information.module';
import { ROOT_REDUCERS } from './ngrx/app.state';
import { AutoValorationEffects } from './ngrx/auto-valoration-form/auto-valoration.effects';
import { PragmaticInfoEffects } from './ngrx/pragmatic-info/pragmatic-info.effects';
import { ValorationEffects } from './ngrx/valoration-form/valoration.effects';
import { NotFoundModule } from './pages/404/404.module';
import { LoginModule } from './pages/login/login.module';
import { SeniorityService } from './services/seniority.service';
import { SiteDataCleanerService } from './services/site-data-cleaner.service';
import { VersionCheckService } from './services/version-check.service';

registerLocaleData(localeEsCo, 'es-Co');
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    ToastModule,
    LoginModule,
    NotFoundModule,
    LoadingModule,
    FormsModule,
    StoreModule.forRoot(ROOT_REDUCERS),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      connectInZone: true,
    }),
    EffectsModule.forRoot([AutoValorationEffects, ValorationEffects, PragmaticInfoEffects]),
    GraphQLModule,
    ModalAtomModule,
    AssessmentSelfManagementInformationModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-Co' },
    SeniorityService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: versionCheckInitializerFactory,
      deps: [HttpClient, SiteDataCleanerService, VersionCheckService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
